/* eslint-disable no-throw-literal */
import {
  GET_PERSONNEL_QUESTION_ALL,
  GET_BUSINESS_QUESTION_ALL,
  GET_ABILITY_QUESTION_LIST,
  ABILITY_QUESTION_DELETE,
  ABILITY_QUESTION_CREATE,
  GET_ABILITY_QUESTION_DETAIL,
  ABILITY_QUESTION_UPDATE
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_PERSONNEL_QUESTION_ALL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/evaluate/ability_questions/personals_all_get', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_BUSINESS_QUESTION_ALL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/evaluate/ability_questions/businesses_all_get', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    [GET_ABILITY_QUESTION_LIST] ({dispatch}, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/master/evaluate/ability_questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [ABILITY_QUESTION_DELETE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiDelete', {url: `/master/evaluate/ability_questions/${params.data.id}`})
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [ABILITY_QUESTION_CREATE] ({dispatch}, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPost', { url: '/master/evaluate/ability_questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [GET_ABILITY_QUESTION_DETAIL] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: `/master/evaluate/ability_questions/${params.id}/edit` })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [ABILITY_QUESTION_UPDATE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: `/master/evaluate/ability_questions/${params.id}`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ability-question.js